module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Qaflo - Complete ERP & Workflow Platform","short_name":"Qaflo","start_url":"/","background_color":"#ffffff","theme_color":"#0D9488","display":"minimal-ui","icon":"src/assets/img/logo/app-icon.svg","include_favicon":false,"description":"Qaflo - Complete ERP & Workflow Platform for project-based businesses.","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"db9293eb5c141325a386557fbf2d23be"},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
